import { render } from "./LivrateurBody.vue?vue&type=template&id=1cad2fd2&scoped=true"
import script from "./LivrateurBody.vue?vue&type=script&lang=js"
export * from "./LivrateurBody.vue?vue&type=script&lang=js"

import "./LivrateurBody.vue?vue&type=style&index=0&id=1cad2fd2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cad2fd2"]])

export default __exports__